import { Component, Input, Output, EventEmitter } from '@angular/core';

@Component({selector: 'app-accordion-group',
  templateUrl: './accordion.group.component.html',
  standalone: false,
})
export class AccordionGroupComponent {

  /**
   * If the panel is opened or closed
   */
  @Input() opened = false;

  /**
   * Text to display in the group title bar
   */
  @Input() title: string;

  /**
   * Emitted when user clicks on group titlebar
   * @type {EventEmitter<any>}
   */
  toToggle(event: Event) {
    event.preventDefault();
    this.toggled.emit();
  }
  @Output() toggled: EventEmitter<any> = new EventEmitter<any>();
}
